export const getSearchQueryParamName = () => "q";
export const getSortQueryParamName = () => "sort";
export const getFilterQueryParamName = (filterType) => `${filterType}_filter`;
